// src/constants/chatConstants.js
export const AI_RESPONSE_TYPES = {
  MESSAGE: 'message',
  PREFERENCE: 'preference',
  ITINERARY: 'itinerary',
  ERROR: 'error'
};

export const CONVERSATION_STAGES = {
  INITIAL: 'initial',
  ACTIVITY: 'activity',
  CUISINE: 'cuisine',
  TIER: 'tier',
  COMPLETE: 'complete',
  CUSTOM: 'custom'
};